import { ViewStream } from "spyne";
import { PageDocsTraits } from "traits/page-docs-traits";
import { PageDocItemsTraits } from "traits/page-doc-items-traits";
import { PageDocsItemTitleExamples } from 'components/pages/page-docs-item-title-examples';
import { PageDocsItemBlock } from "components/pages/page-docs-item-block";
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import { PageItemCoreTraits } from 'traits/page-item-core-traits';
import { ScrollSpyTraits } from "traits/scroll-spy-traits";

export class PageDocsItem extends ViewStream {
  constructor(props = {}) {
    props.traits = [
      PageDocsTraits,
      PageDocItemsTraits,
      ScrollSpyTraits,
      PageLoadDocsTraits,
      PageItemCoreTraits
    ];
    props.id = props.data.itemId;
    props.dataset = PageDocItemsTraits.pageDocItems$CreateDataset(props);

    //props.id = PageDocItemsTraits.pageDocItems$CreateItemId(props);
    // props.class = `docs-item docs-item-${props.data.menuData.itemType}`;
    props.class = PageDocItemsTraits.pageDocItems$CreateItemClass(props);
    //console.log("PROPS DATA ",props.data.menuData.itemType,props.data)
    props.template = PageDocItemsTraits.pageDocItems$GetItemTemplate(
      props.data.menuData.itemType,
    );
    if (props.pageId==='docs'){
     // props.template = props.template.replace(/(.*)(<span>.*</span>)(.*)/, "$1<span>YAYA</span>$3")
      //console.log("THE TEMPLATE IS ",props.data);
      const eyebrow = props?.data?.eyebrow || "missing";
      props.template = String(props.template).replace(/(<span>).*?(<\/span>)/i, `$1${eyebrow}$2`);
    }

    super(props);
  }

  onBeforeDispose() {
    if (this?.props?.isObserved === true) {
      this.scrollSpy$ObserverRemove();
    }
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onAddBlocks() {
    const { pageId } = this.props;
    const addBlockItem = (data, blockNum) => {
      const parentVsid = this.props.id;

      const { blockType } = data;
      //console.log("ADD THE BLOKS ",{blockType, pageId, data}, this.props);

      //console.log("blockType ",{blockType,data})

      //if (blockType === 'heading') {

      if (blockType === 'pageItem'){
        this.pageItemCore$AddPageItems([data]);


      } else {
        this.appendView(
            new PageDocsItemBlock({ data, blockNum, pageId, parentVsid }),
        );
      }


      //}
    };

    this.props.data.block.forEach(addBlockItem);
  }



  onRendered() {
    this.scrollSpy$ObserverAdd();

    if (this.props.data.block) {
      this.onAddBlocks();
    }
    this.pageLoad$TrimLinebreaks();

    if (this.props.data?.addArrowNav){
      const {data} = this.props;
      const delayUpdate = ()=>{
        const el = this?.props?.el$("h1")?.el;

       //console.log("ADD ARROW NAV ", {el},this.props.el);
        if (el === undefined){
          return;
        }

        this.appendView(new PageDocsItemTitleExamples({el, data}));
      }
      window.setTimeout(delayUpdate, 1000);
    }

  }
}
